export default __webpack_public_path__ + "assets/images/c_sales.f6c7b4c.jpg";